import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { distanceOfTimeInWords } from '../../../../../../Time';
import { L, T } from '../../../../../../Translations';

interface Props {
  lastLoginAt: Maybe<Date>;
}

function LastLoginCell({ lastLoginAt }: Props) {
  return lastLoginAt
    .map((date) => (
      <div style={{ fontSize: 'var(--text-sm)' }}>
        <div className="text-foreground">
          <L localizeable={date} format="short-month-day-year" />
        </div>
        <div className="text-muted-foreground" style={{ fontSize: 'var(--text-xs)' }}>
          <T {...distanceOfTimeInWords(new Date(), date)} />
        </div>
      </div>
    ))
    .getOrElse(() => (
      <span className="text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
        <T kind="Never" />
      </span>
    ));
}

export default observer(LastLoginCell);
